// 使用方式举例:this.$store.getters.opModuleMap
const getters = {
  opModuleMap: state => state.system.opModuleMap,
  tenantId: state => state.user.tenantId,
  isStandalong: state => window.$envUtils('VUE_APP_STANDALONE') === 'true',
  workStatus: state => state.user.status
}
export default getters
